var map = {
	"./2AGK.png": 59126,
	"./5AGK.png": 45915,
	"./6AGK.png": 39111,
	"components/Catalog/AGK/img/allDoor/mtb/2AGK.png": 59126,
	"components/Catalog/AGK/img/allDoor/mtb/5AGK.png": 45915,
	"components/Catalog/AGK/img/allDoor/mtb/6AGK.png": 39111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98085;